import React from "react";
import { FieldHeading } from "./FieldHeading.js";
import { FieldItem } from "./FieldItem.js";
import { QueryItem } from "../../../model/accounting/query/QueryItem.js";

type Props = {
  expensesEu: number;
  expensesEuItems: QueryItem[];
};

/**
 * Generates table rows for the VAT report field 6.
 */
export const VatReportField6 = ({ expensesEu, expensesEuItems }: Props) => {
  return (
    <>
      <FieldHeading
        label="Väli 6"
        description="Kauba ühendusesisene soetamine ja teise liikmesriigi maksukohustuslaselt saadud teenused kokku."
        total={expensesEu}
        itemsCount={expensesEuItems.length}
      />
      {expensesEuItems.map((queryItem) => (
        <FieldItem key={queryItem.id} queryItem={queryItem} />
      ))}
    </>
  );
};
